export default {
  root: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    padding: "0 0.75em"
  }
}
